namespace GeniuzPOS.InventoryReport {
    export interface IcReportWhsEomForm {
    }

    export class IcReportWhsEomForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReportWhsEom';
    }
}
